import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MedigiComponentCopyService {
  cards = {
    largeCard: {
      generalQuotes: [
        {
          quote:
            "\u0022 Lots of variety - in meds, pricing, vendors, and remaining expiration.  There's something for everyone :) \u0022",
          quoterBold: '',
          quoter: 'University of Michigan Health-West',
        },
        {
          quote:
            '\u0022 I like the prices, excellent communication, and fantastic customer service. \u0022',
          quoterBold: '',
          quoter: 'Indiana University Health',
        },
        {
          quote:
            '\u0022 We love the ability to place offers to increase savings, and all the great people! \u0022',
          quoterBold: '',
          quoter: 'Corewell Health',
        },
        {
          quote:
            '\u0022 Medigi provides us with cost savings, as well as helping to get us through shortages. \u0022',
          quoterBold: '',
          quoter: 'Guthrie',
        },
      ],
      homepage: [
        {
          quote:
            '\u0022 We love the ability to purchase meds directly from manufacturers quickly and easily. Most of the time, that is not true when dealing directly with manufacturers! \u0022',
          quoterBold: '',
          quoter: 'Intensive Specialty Hospital',
        },
        {
          quote:
            '\u0022 I can easily find medications, prices, expiration dating, and order requirements. I love the bidding feature; makes it fun! \u0022',
          quoterBold: '',
          quoter: 'Guadalupe Regional Medical Center',
        },
        {
          quote:
            '\u0022 We can find medications we require when other sources cannot provide them. \u0022',
          quoterBold: '',
          quoter: 'Integris',
        },
      ],
      pharmacyPage: {
        quoteCards: [
          {
            quote:
              '\u0022 medigi provides us with cost savings as well as helping to get us through shortages. \u0022',
            quoterBold: 'medigi Customer',
            quoter: 'Guthrie',
          },
          {
            quote:
              '\u0022 The site is easy to use, and many times there are good saving opportunities. \u0022',
            quoterBold: 'medigi Customer',
            quoter: 'Christiana Care Health Systems',
          },
          {
            quote:
              '\u0022 Some items we can’t find at our wholesaler due to backorder, but we can find it at medigi. Our rep is very helpful! \u0022',
            quoterBold: 'medigi Customer',
            quoter: 'Trinity Health',
          },
        ],
        buttonCard: [
          {
            copy: 'what are you waiting for? it’s free to join!',
            subCopy: 'Register today and experience the medigi difference.',
            button: {
              text: 'create your account now',
              color: 'yellow',
              icon: 'chevronright',
              link: '/registration/buyer',
              type: 'button',
              styles: {
                width: '',
              },
            },
          },
        ],
      },
      manufacturerPage: {
        quoteCards: [
          {
            quote:
              '\u0022 medigi provides us with cost savings as well as helping to get us through shortages. \u0022',
            quoter: 'Guthrie',
          },
          {
            quote:
              '\u0022 medigi provides us with cost savings as well as helping to get us through shortages. \u0022',
            quoter: 'Guthrie',
          },
          {
            quote:
              '\u0022 medigi provides us with cost savings as well as helping to get us through shortages. \u0022',
            quoter: 'Guthrie',
          },
        ],
        buttonCard: [
          {
            copy: 'ready to join medigi & the future of direct sales?',
            button: {
              text: 'register now',
              color: 'yellow',
              icon: 'chevronright',
              link: '/registration/seller',
              type: 'button',
              styles: {
                width: '',
              },
            },
          },
        ],
      },
      aboutUsPage: {
        buttonCard: [
          {
            copy: 'manufacturers and pharmacies work together at medigi to create cost savings and mitigate drug shortages.',
            button: {
              text: 'find out how',
              color: 'yellow',
              icon: 'chevronright',
              link: '',
              type: 'button',
              styles: {
                width: '',
              },
            },
          },
        ],
      },
    },
    stepCards: {
      homePage: [
        {
          title: 'STEP 1',
          copy: 'Drug manufacturers list their chosen inventory on the medigi platform',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/factory-icon.svg',
        },
        {
          title: 'STEP 2',
          copy: 'Hospital systems, medical centers, and pharmacies shop, negotiate, and order product(s) through medigi',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/desktop-icon.svg',
        },
        {
          title: 'STEP 3',
          copy: 'Manufacturers ship products directly to the purchaser',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/shipping-icon.svg',
        },
        {
          title: 'STEP 4',
          copy: 'Shipments are tracked in real time',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/phone-icon.svg',
        },
        {
          title: 'STEP 5',
          copy: 'Medigi consolidates and sends invoices to the purchaser after the products are received',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/envelope-icon.svg',
        },
        {
          title: 'STEP 6',
          copy: 'We collect and disburse payments to the respective manufacturers',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/check-ribbon-icon.svg',
        },
      ],
      pharmayPage: [
        {
          title: 'STEP 1',
          copy: 'Explore invetory lists on medigi for full-dated drugs, MedShorts for short-dated, and 503B for compounded drugs',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/desktop-icon.svg',
        },
        {
          title: 'STEP 2',
          copy: 'Secure the best deals directly',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/check-ribbon-icon.svg',
        },
        {
          title: 'STEP 3',
          copy: 'All products ship directly from the manufacturer or designated 3PL',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/shipping-icon.svg',
        },
        {
          title: 'STEP 4',
          copy: 'Know exacrly when new incentory will arrive via real-time shipment updates',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/phone-icon.svg',
        },
        {
          title: 'STEP 5',
          copy: 'Receive a consolidated invoice after products arrive',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/envelope-icon.svg',
        },
        {
          title: 'STEP 6',
          copy: 'One payment is collected and disbursed to the respective manufacturer(s)',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/step-1.svg',
        },
      ],
      manufacturerPgae: [
        {
          title: 'STEP 1',
          copy: 'List chosen inventory on the medigi platform',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/factory-icon.svg',
        },
        {
          title: 'STEP 2',
          copy: 'Pharmacies order your product(s)',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/desktop-icon.svg',
        },
        {
          title: 'STEP 3',
          copy: 'You ship products directly or from your designated 3PL to the pharmacy or',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/shipping-icon.svg',
        },
        {
          title: 'STEP 4',
          copy: 'Shipments are tracked in real-time & medigi updates facilities directly on order status',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/phone-icon.svg',
        },
        {
          title: 'STEP 5',
          copy: 'medigi sends consolidated invoices',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/envelope-icon.svg',
        },
        {
          title: 'STEP 6',
          copy: 'Payments are collected on your behalf',
          image:
            'assets/img/static-pages/medigi/v2-images/step-card-icons/check-ribbon-icon.svg',
        },
      ],
    },
    drugCards: [
      {
        image:
          '/assets/img/static-pages/medigi/v2-images/drugs/generic-drugs.svg',
        copy: 'Generic drugs',
      },
      {
        image:
          '/assets/img/static-pages/medigi/v2-images/drugs/branded-drugs.svg',
        copy: 'Branded drugs',
      },
      {
        image:
          '/assets/img/static-pages/medigi/v2-images/drugs/injectables.svg',
        copy: 'Injectables',
      },
      {
        image: '/assets/img/static-pages/medigi/v2-images/drugs/infusion.svg',
        copy: 'Infusion meds',
      },
      {
        image: '/assets/img/static-pages/medigi/v2-images/drugs/oncology.svg',
        copy: 'Oncolytic treatments',
      },
      {
        image: '/assets/img/static-pages/medigi/v2-images/drugs/gray-plus.svg',
        copy: 'and many more!',
      },
    ],
  };

  carousels = {
    medigiSitesCarousels: [
      {
        image: 'assets/img/logos/medigi-logo-blue.svg',
        alt: 'medigi logo',
        copy: 'full-dated portfolios',
      },
      {
        image: 'assets/img/logos/ms_teal_logo.svg',
        alt: 'medshorts logo',
        copy: 'surplus & short-dated deals',
      },
      {
        image: 'assets/img/logos/503B_Color.svg',
        alt: '503b logo',
        copy: 'compounded medications sold by FDA-registered outsourcing facilities',
      },
    ],
  };

  faq = {
    pharmacy: [
      {
        question: 'What can medigi do for me?',
        answer:
          'medigi is a virtual marketplace for healthcare systems who value cost containment opportunities and improved medication access. While the primary benefit of the platform is instant savings for hospital pharmacies, we have also helped pharmacies nationwide access medications on the ASHP and FDA shortage list. These opportunities are easily distinguishable through your personal portal with tabs for “Best Savings” and “Drug Shortages”, and can be optimized to the specific needs of your pharmacy. Allowing pharmacies direct access to manufacturer inventory is not only beneficial when facing budgeting constraints, drug shortages or limited allocations, but also drives a positive environmental impact through reduction of medical waste. Using your own purchasing analytics intelligently to source short-dated drugs from manufacturers helps to prevent pharmaceutical disposal.',
      },
      {
        question: 'Why should I sign up?',
        answer:
          'To improve resiliency, pharmacy departments should have a best-backup in place whenever traditional channels don’t have adequate supply for patient needs. medigi is a proven drug shortage resource with a comprehensive catalog of full-dated pharmaceuticals, compounded medications (503B.com), and MedShorts, featuring short-dated discounted stock to help with cost savings initiatives.',
      },
      {
        question: 'What kind of products are on the marketplace?',
        answer:
          'The real-time exchange features pharmaceuticals from a variety of manufacturers listing generic injectables, antibiotics, oncology medications, oral solids, unit dose, brand, biosimilars, and specialty products. Any valid NDC from participating source manufacturers are eligible for listing.',
      },
      {
        question: 'Where does the product come from?',
        answer:
          'The platform hosts source FDA registered manufacturers with products approved for sale in the United States. Medications are shipped directly from the pharmaceutical manufacturer processing the order. There are no secondary or tertiary (also known as grey market) distributors selling product on the marketplace, providing peace of mind that there is a clean pedigree between the drug company and the ordering facility.',
      },
      {
        question: 'Who uses the marketplace?',
        answer:
          'Directors of Pharmacy, C-Tech Buyers, and Procurement Managers at health system pharmacies, academic medical centers, community oncology practices, home infusion, outpatient clinics, retail pharmacies, and surgery centers.',
      },
      {
        question: 'How much does it cost?',
        answer:
          'There is no cost to enroll (it takes 5 minutes), and no purchasing obligations. You’ll select from a choice of payment terms at registration that will determine the associated transaction fee.',
      },
      {
        question: 'How long does it take to order?',
        answer:
          'In our first community survey, most reported they were able to impact significant savings spending no more than 1 hour a week placing MedShorts orders. Some buyers only spend a few minutes on the platform if they go in knowing what they are looking for.',
      },
    ],
    manufacturer: [
      {
        question: 'What types of manufacturers is medigi for?',
        answer:
          'medigi is for FDA-approved manufacturers of commercially available drugs and FDA registered outsourcing facilities. It provides manufacturers the opportunity to list inventory directly to pharmacies.',
      },
      {
        question: 'What types of pharmacies does medigi serve?',
        answer:
          'medigi serves hospitals, infusion pharmacies, surgery centers, long term care facilities, and more. Pharmacies must have a valid state license to enroll.',
      },
      {
        question: 'Who ships the product?',
        answer:
          'Products are shipped directly from manufacturers or their designated 3PLs to the ordering pharmacy.',
      },
      {
        question: 'Who is responsible for billing and collections?',
        answer:
          'medigi performs all billing and collection services on behalf of manufacturers.',
      },
      {
        question: 'What kind of support does medigi offer customers?',
        answer:
          'medigi has teams dedicated to customer service, pharmacy support, and manufacturer support.',
      },
    ],
  };

  valueProps = {
    pharmacy: [
      {
        image:
          'assets/img/static-pages/medigi/v2-images/value-prop-icons/plus-circle.svg',
        copy: 'One vendor to set up access to 80+ manufacturers',
      },
      {
        image:
          'assets/img/static-pages/medigi/v2-images/value-prop-icons/streamline.svg',
        copy: 'Streamline the direct purchasing process',
      },
      {
        image:
          'assets/img/static-pages/medigi/v2-images/value-prop-icons/envelope-icon.svg',
        copy: 'Consolidated invoicing',
      },
      {
        image:
          'assets/img/static-pages/medigi/v2-images/value-prop-icons/customer-service.svg',
        copy: 'Dedicated account manager and live customer support',
      },
      {
        image:
          'assets/img/static-pages/medigi/v2-images/value-prop-icons/laptop.svg',
        copy: 'Easy-to-use web-based sourcing technology',
      },
      {
        image:
          'assets/img/static-pages/medigi/v2-images/value-prop-icons/graph.svg',
        copy: 'Custom analytics to show performance and opportunities',
      },
      {
        image:
          'assets/img/static-pages/medigi/v2-images/value-prop-icons/basket.svg',
        copy: 'Open marketplace — medigi is a neutral party with no prime vendor',
      },
      {
        image:
          'assets/img/static-pages/medigi/v2-images/value-prop-icons/community.svg',
        copy: 'Unified customer experience',
      },
    ],
    manufacturer: [
      {
        image:
          'assets/img/static-pages/medigi/v2-images/value-prop-icons/community.svg',
        copy: 'Access to a community of pharmacies',
      },
      {
        image:
          'assets/img/static-pages/medigi/v2-images/value-prop-icons/negotiation.svg',
        copy: 'Direct negotiation',
      },
      {
        image:
          'assets/img/static-pages/medigi/v2-images/value-prop-icons/order.svg',
        copy: 'Integrate order processing with 3PLs',
      },
      {
        image:
          'assets/img/static-pages/medigi/v2-images/value-prop-icons/laptop.svg',
        copy: 'Easy-to-use website & listing management',
      },
      {
        image:
          'assets/img/static-pages/medigi/v2-images/value-prop-icons/streamline.svg',
        copy: 'Streamline the direct sales process',
      },
      {
        image:
          'assets/img/static-pages/medigi/v2-images/value-prop-icons/customer-service.svg',
        copy: 'Excellent customer service',
      },
      {
        image:
          'assets/img/static-pages/medigi/v2-images/value-prop-icons/product-matches.svg',
        copy: 'Product matches to pharmacies',
      },
      {
        image:
          'assets/img/static-pages/medigi/v2-images/value-prop-icons/analytics.svg',
        copy: 'Data and analytics for real-time reports on your products',
      },
    ],
  };

  leardershipTeam = [
    {
      name: 'Blake Powers',
      jobTitle: 'CHIEF EXECUTIVE OFFICER',
      description:
        'Began his career inside the operations of a home infusion pharmacy, and serves as medigi’s visionary and integrator.',
      socialUrl: 'https://www.linkedin.com/in/blake-powers-08160916/',
    },
    {
      name: 'Raphael Esch',
      jobTitle: 'CHIEF TECHNOLOGY OFFICER',
      description:
        'Enterprise software architect with extensive eCommerce experience, lead all in-house development and trained our team of engineers.',
      socialUrl: 'https://www.linkedin.com/in/raphael-e-89ba38/',
    },
    {
      name: 'Jon Crabb, PharmD',
      jobTitle: 'CHIEF PHARMACY OFFICER',
      description:
        'Informatics pharmacist with a background in both hospital pharmacy and big data, is our lead for reporting and analytics.',
      socialUrl: 'https://www.linkedin.com/in/jonathan-crabb-pharmd-a2665b47/',
    },
    {
      name: 'Camille Ricci',
      jobTitle: 'VICE PRESIDENT, PARTNER ALLIANCES',
      description:
        'Previously working with pharmaceutical manufactures in the GPO space, she manages our supplier client relationships.',
      socialUrl: 'https://www.linkedin.com/in/camillenricci/',
    },
    {
      name: 'Matt Tomlinson',
      jobTitle: 'VICE PRESIDENT OF FINANCE',
      description:
        'With banking and corporate media experience, he oversees the financial and human resource operations of the company.',
      socialUrl: 'https://www.linkedin.com/in/matthewctomlinson/',
    },
    {
      name: 'Laura Powers',
      jobTitle: 'MARKETING DIRECTOR',
      description:
        'Artist, event planner, and designer who manages our branding, social media, and marketing campaigns.',
      socialUrl: 'https://www.linkedin.com/in/laura-powers-4b7320247/',
    },
  ];

  medigiTimelineCards = [
    {
      date: 'May 2015',
      copy: 'MedShorts is established.',
      image:
        '/assets/img/static-pages/medigi/v2-images/company-logos/medshorts-logo-gradient.svg',
    },
    {
      date: 'April 2016',
      copy: 'MedShorts began trialing pharma eCommerce with 503B outsourcing facilities.',
      image: '',
    },
    {
      date: 'July 2017',
      copy: 'We were awarded a national GPO contract, allowing us to pivot to pharma manufacturers.',
      image: '',
    },
    {
      date: 'March 2018',
      copy: 'MedShorts celebrates its go-to-market launch!',
      image: '',
    },
    {
      date: 'October 2018',
      copy: 'We received a seed investment led by Bindly Capital.',
      image: '',
    },
    {
      date: 'March 2020',
      copy: 'We secure a major 3PL eCommerce solution contract.',
      image: '',
    },
    {
      date: 'October 2020',
      copy: 'MedShorts debuted a first-of-its kind bidding feature.',
      image: '',
    },
    {
      date: 'August 2021',
      copy: 'We surpass $25M in marketplace sales!',
      image: '',
    },
    {
      date: 'May 2022',
      copy: 'REBRAND TIME: medigi beta is released.',
      image: '/assets/img/logos/medigi-logo-blue.svg',
    },
    {
      date: 'December 2022',
      copy: 'medigi offically launches on a national scale',
      image: '',
    },
  ];

  constructor() {}
}
